import { lazy } from 'react';
import PlatformModules from '../../../core/accessControl/Modules';
import ProtectedRoute from '../../../core/accessControl/ProtectedRoute';
import AprovaLiveLock from '../../../core/components/organism/AprovaLiveLock';
import Challenge60DaysLock from '../../../core/components/organism/Challenge60DaysLock';
import ChallengePage from '../pages/Challenge';

const AprovaLivePage = lazy(() => import('../pages/AprovaLive'));
const LivesPage = lazy(() => import('../pages/Lives'));
const MonitoringPage = lazy(() => import('../pages/Monitoring'));
const PlayerAprovaLivePage = lazy(() => import('../pages/PlayerAprovaLive'));
const PlayerLivesPage = lazy(() => import('../pages/PlayerLives'));
const AprovaLiveSimulationRunning = lazy(() => import('../components/SimulationRunning'));
const AprovaLiveSimulationFeedback = lazy(() => import('../components/SimulationFeedback'));
const PlayerMonitoringPage = lazy(() => import('../pages/PlayerMonitoring'));
const QuestionsMonitoringPage = lazy(() => import('../pages/QuestionsMonitoring'));

const moduleAprovaLive = [PlatformModules.APROVA_LIVE.ID];
const modulesLives = [PlatformModules.AULAS_AO_VIVO.ID];
const modulesMonitorias = [PlatformModules.MONITORIAS.ID];
const modulesChallenge = [PlatformModules.CHALLENGE_60_DIAS.ID];

export const AprovaLiveRoutes = [
  {
    path: '/ao-vivo/aprova-live',
    element: (
      <ProtectedRoute
        modulesAllowed={moduleAprovaLive}
        element={<AprovaLivePage />}
        customLock={<AprovaLiveLock />}
      />
    ),
  },
  {
    path: '/ao-vivo/aprova-live/:slug',
    element: (
      <ProtectedRoute
        modulesAllowed={moduleAprovaLive}
        element={<PlayerAprovaLivePage />}
        customLock={<AprovaLiveLock />}
      />
    ),
  },
  {
    path: '/ao-vivo/monitorias/:slug',
    element: (
      <ProtectedRoute
        modulesAllowed={modulesMonitorias}
        element={<PlayerMonitoringPage />}
      />
    ),
  },
  {
    path: '/ao-vivo/monitorias/questions/:id',
    element: (
      <ProtectedRoute
        modulesAllowed={modulesMonitorias}
        element={<QuestionsMonitoringPage />}
      />
    ),
  },
  {
    path: '/ao-vivo/aprova-live/simulado/:slug',
    element: (
      <ProtectedRoute
        modulesAllowed={moduleAprovaLive}
        element={<AprovaLiveSimulationRunning />}
        customLock={<AprovaLiveLock />}
      />
    ),
  },
  {
    path: '/ao-vivo/aprova-live/simulado/:slug/feedback',
    element: (
      <ProtectedRoute
        modulesAllowed={moduleAprovaLive}
        element={<AprovaLiveSimulationFeedback />}
        customLock={<AprovaLiveLock />}
      />
    ),
  },
  {
    path: '/ao-vivo/lives',
    element: (
      <ProtectedRoute modulesAllowed={modulesLives} element={<LivesPage />} />
    ),
  },
  {
    path: '/ao-vivo/lives/:slug',
    element: (
      <ProtectedRoute
        modulesAllowed={modulesLives}
        element={<PlayerLivesPage />}
      />
    ),
  },

  {
    path: '/ao-vivo/monitorias',
    element: (
      <ProtectedRoute
        modulesAllowed={modulesMonitorias}
        element={<MonitoringPage />}
      />
    ),
  },
  {
    path: '/ao-vivo/desafio-60-dias',
    element: (
      <ProtectedRoute
        modulesAllowed={modulesChallenge}
        element={<ChallengePage />}
        customLock={<Challenge60DaysLock />}
      />
    ),
  },
  {
    path: '/ao-vivo/desafio-60-dias/:slug',
    element: (
      <ProtectedRoute
        modulesAllowed={modulesChallenge}
        element={<PlayerAprovaLivePage origin='challenge' />}
        customLock={<Challenge60DaysLock />}
      />
    ),
  },
  {
    path: '/ao-vivo/desafio-60-dias/simulado/:slug',
    element: (
      <ProtectedRoute
        modulesAllowed={modulesChallenge}
        element={<AprovaLiveSimulationRunning origin='challenge' />}
        customLock={<Challenge60DaysLock />}
      />
    ),
  },
  {
    path: '/ao-vivo/desafio-60-dias/simulado/:slug/feedback',
    element: (
      <ProtectedRoute
        modulesAllowed={modulesChallenge}
        element={<AprovaLiveSimulationFeedback origin='challenge' />}
        customLock={<Challenge60DaysLock />}
      />
    ),
  },
];
